import React from 'react';

import { MovimentacaoListComp } from './components';

import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function MovimentacaoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['FINANCEIRO_NOTA_FISCAL_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <MovimentacaoListComp />
        </ListagemProvider>
    );
}
